<template>
  <div class="page-news">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/ah`">招工招生</el-breadcrumb-item>
        <el-breadcrumb-item>{{ metaData.name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content news-content">
        <column-header2 :data="metaData"></column-header2>
        <ic-news :data="columnData" :type="metaData.type"></ic-news>
        <el-pagination class="g-pagination" background layout="prev, pager, next" :total="1000"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from "api/app";
import News from "_c/News";
import ColumnHeader from "_c/ColumnHeader2";
const linkDecorator = item => {
  item.link = this.$subsitePrefix + "/ah/column/detail/" + item.id;
  return item;
};
export default {
  data() {
    return {
      metaData: { name: "招生计划" },
      columnData: []
    };
  },
  created() {
    this.init();
  },
  components: {
    [News.name]: News,
    [ColumnHeader.name]: ColumnHeader
  },
  watch: {
    $route() {
      this.init();
    }
  },
  methods: {
    loadData() {
      getData({ name: "SpecialJobFairEnterprise" }).then(res => {
        const arr = [];
        res.forEach(element => {
          arr.push({
            Headline: element.RecruitmentPosition,
            Summary: element.EnterpriseName,
            Id: element.Id,
            name: 'SpecialJobFairEnterprise'
          })
        });
        this.columnData = (arr || []).map(linkDecorator);
      });
    },
    init() {
      this.id = this.$route.params.id;
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-news {
  background: #f6f6f9;
  padding-bottom: 40px;
  ::v-deep .comp-news {
    padding: 5px 0 20px 0;
  }
  .news-content {
    padding-bottom: 40px;
    ::v-deep .comp-column-header {
      padding: 0;
    }
  }
}
</style>
